import React from "react"
import TableGroups from "@/components/reservations/table_groups"
import CalendarPicker from "@/components/calendar_buttons/picker"
import CalendarToday from "@/components/calendar_buttons/today"
import { UiLink } from "@/components/ui"
import { usePanelLink } from "@/shared/hooks"
import i18n from "@/i18n"

const VenuePlanIcon: React.FC = () => (
  <svg viewBox="0 0 12 12" className="w-[11px] h-[10px]" fill="none" aria-hidden="true">
    <path
      d="M8.115 3.041h2.539a.846.846 0 0 1 .846.846v5.924a.846.846 0 0 1-.846.846H6.422a.846.846 0 0 1-.846-.846V6.426"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M5.578 6.424H1.346A.846.846 0 0 1 .5 5.577V1.346A.846.846 0 0 1 1.346.5h5.924a.846.846 0 0 1 .846.846v1.693"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
)

const ReservationsNavigation: React.FC = () => {
  const linkTo = usePanelLink()

  return (
    <div className="flex justify-between items-center" data-testid="panel-reservations-nav">
      <div className="flex items-center">
        <CalendarPicker />
        <div className="ml-5">
          <CalendarToday />
        </div>
      </div>

      <div className="flex gap-[15px] items-center justify-end">
        <TableGroups />
        <UiLink
          to={linkTo("reservations/list")}
          activeProps={{ color: "secondary", to: linkTo("reservations") }}
          size="small"
          className="px-[15px] rounded-[5px] !border-[#eee] !text-xs text-neutral-700"
          data-testid="panel-reservations-nav-list-link"
        >
          {i18n.t("app.reservations_navigation.reservations")}
        </UiLink>
        <UiLink
          to={linkTo("reservations/venue_plan")}
          activeProps={{ color: "secondary" }}
          size="small"
          className="px-[15px] rounded-[5px] !border-[#eee] !text-xs text-neutral-700 gap-[5px]"
          data-testid="panel-reservations-nav-venue-plan-link"
        >
          <VenuePlanIcon />
          {i18n.t("app.reservations_navigation.venue_plan")}
        </UiLink>
      </div>
    </div>
  )
}

export default ReservationsNavigation
